(() => {
  const THRESHOLD = 25

  const apply = root => {
    root.querySelectorAll('.badges').forEach(wrap => {
      // tag wrappers that actually contain the sale badge (for mobile CSS)
      const sale = wrap.querySelector('.badge--onsale')
      if (!sale) return
      wrap.classList.add('badges--has-onsale')

      // 30%+ turns red
      const m = (sale.textContent || '').match(/(\d+)\s*%/)
      if (m && parseInt(m[1], 10) >= THRESHOLD) sale.classList.add('badge--onsale-high')
    })
  }

  const start = () => {
    apply(document)
    // handle dynamic renders on collection pages
    new MutationObserver(() => apply(document)).observe(document.body, { childList: true, subtree: true })
    document.addEventListener('shopify:section:load', e => apply(e.target))
    document.addEventListener('shopify:section:select', e => apply(e.target))
    window.ofwApplyBadges = () => apply(document) // manual debug hook
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()